import React, { useState, useEffect, useRef } from "react";
import "../../resources/css/layout.css";
import "../../resources/css/common.css";
//import TopBn from "../../resources/img/img-topBn-2501.png";

const Header = ({ onBannerClose, children }) => {
  const [isBannerVisible, setIsBannerVisible] = useState(true);
  const [isHeaderVisible, setIsHeaderVisible] = useState(true); // 헤더 가시성 상태
  const [lastScrollTop, setLastScrollTop] = useState(0); // 마지막 스크롤 위치

  const [isAllMenuOpen, setIsAllMenuOpen] = useState(false);
  const [, setActiveMenu] = useState(null);
  const menuRef = useRef(null);

  const [activeIndex, setActiveIndex] = useState(null);
  const liRefs = useRef([]);

  useEffect(() => {
    const today = new Date().getDate();
    const storedDate = localStorage.getItem("today");

    if (storedDate && parseInt(storedDate) === today) {
      setIsBannerVisible(false);
    }
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;

      if (scrollTop > 100) {
        // 100px 이상일 때
        if (scrollTop > lastScrollTop) {
          setIsHeaderVisible(false); // 아래로 스크롤할 때 헤더 숨김
        }
      } else {
        setIsHeaderVisible(true); // 100px 이하일 때는 항상 보임
      }

      setLastScrollTop(scrollTop); // 마지막 스크롤 위치 업데이트
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollTop]);

  const topBannerTodayClose = () => {
    const today = new Date().getDate();
    localStorage.setItem("today", today);
    setIsBannerVisible(false);
    onBannerClose();
  };

  const topBannerClose = () => {
    setIsBannerVisible(false);
    onBannerClose(); // 부모 컴포넌트의 함수를 호출하여 Popup 상태 변경
  };
  
  useEffect(() => {
    const container = document.getElementById("container");

    if (container) {
      if (!isBannerVisible) {
        // isBannerVisible이 false일 때 #container에 onPopup 클래스 추가
        container.classList.add("onPopup");
      } else {
        // isBannerVisible이 true일 때 #container에서 onPopup 클래스 제거
        container.classList.remove("onPopup");
      }
    }
  }, [isBannerVisible]); // isBannerVisible 값이 변경될 때마다 실행

  useEffect(() => {
    const handleMouseEnter = (event) => {
      const target = event.currentTarget;
      target.classList.add("sel");
      const depth2 = target.querySelector(".depth2");
      if (depth2) {
        depth2.classList.add("visible"); // depth2 보이기
        console.log("Depth2 shown:", depth2);
      }
      document.getElementById("header").classList.add("sel");
    };

    const handleMouseLeave = (event) => {
      event.currentTarget.classList.remove("sel");
      const depth2 = event.currentTarget.querySelector(".depth2");
      if (depth2) depth2.classList.remove("visible"); // depth2 숨기기
      document.getElementById("header").classList.remove("sel");
    };

    const depth1Items = document.querySelectorAll("#header .gnb .depth1");

    depth1Items.forEach((item) => {
      item.addEventListener("mouseenter", handleMouseEnter);
      item.addEventListener("mouseleave", handleMouseLeave);
      item.addEventListener("focusout", handleMouseLeave);
    });

    const container = document.getElementById("container");
    const index = document.getElementById("index");

    if (container) {
      container.addEventListener("focusin", handleMouseLeave);
    }
    if (index) {
      index.addEventListener("focusin", handleMouseLeave);
    }

    return () => {
      depth1Items.forEach((item) => {
        item.removeEventListener("mouseenter", handleMouseEnter);
        item.removeEventListener("mouseleave", handleMouseLeave);
        item.removeEventListener("focusout", handleMouseLeave);
      });
      if (container) {
        container.removeEventListener("focusin", handleMouseLeave);
      }
      if (index) {
        index.removeEventListener("focusin", handleMouseLeave);
      }
    };
  }, []);

  // *************************************************************************************************************************************************

  const toggleAllMenu = () => {
    setIsAllMenuOpen((prev) => {
      const newState = !prev;

      // 스크롤 제어
      if (newState) {
        document.body.style.overflow = "hidden"; // 메뉴가 열리면 스크롤 비활성화
      } else {
        document.body.style.overflow = ""; // 메뉴가 닫히면 스크롤 활성화
      }

      return newState;
    });
  };

  const closeMenu = () => {
    setIsAllMenuOpen(false);
    setActiveMenu(null);
  };

  const handleMenuClick = (index) => {
    // 클릭한 항목과 같은 인덱스면 sel 클래스 제거
    if (activeIndex === index) {
      setActiveIndex(null);
      liRefs.current[index].classList.remove("sel");
    } else {
      // 다른 항목 클릭 시 sel 클래스 추가
      liRefs.current.forEach((li) => li.classList.remove("sel"));
      liRefs.current[index].classList.add("sel");
      setActiveIndex(index);
    }
  };

  useEffect(() => {
    // Close the menu when clicking outside
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        closeMenu();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <header
      id="header"
      className={isHeaderVisible ? "header-visible" : "header-hidden"}
    >
      {isBannerVisible && (
        <div className="top-banner">
          <div className="wrap">
            <a className="btn-event" href="/startProcess">
              <img src="/custom-resources/img/img-topBn.png" alt="배너" />
            </a>
            <a className="btn-today-close" onClick={topBannerTodayClose}>
              <img
                src="/custom-resources/img/btn-topBn-close-today.png"
                alt="오늘 하루 보지 않기"
              />
            </a>
            <a className="btn-close" onClick={topBannerClose}>
              <img src="/custom-resources/img/btn-topBn-close.png" alt="닫기" />
            </a>
          </div>
        </div>
      )}
      <div className="tnb">
        <div className="wrap">
          <div className="lnb">
            <a href="/branch">
              <strong>
                <span style={{ color: "#000000" }}>아소비 교육원 찾기</span>
                <span style={{ color: "#FF8000" }}> 클릭!</span>
              </strong>
            </a>
          </div>
          <div className="rnb">
            <a
              href="https://www.youtube.com/c/%EC%95%84%EC%86%8C%EB%B9%84"
              target="_blank"
              rel="noopener noreferrer"
            >
              유튜브
            </a>
            <a
              href="https://spring.asobi.co.kr/landing/animation_ibosa"
              target="_blank"
              rel="noopener noreferrer"
            >
              애니메이션
            </a>
            <a href="/app">아소비 앱</a>
            <a href="/news">아소비 소식</a>
            <a
              href="https://intra.asobi.co.kr/member/login.php"
              target="_blank"
              rel="noopener noreferrer"
            >
              인트라넷
            </a>
            <a href="/customer">고객센터</a>
          </div>
        </div>
      </div>
      <div className="header">
        <div className="wrap">
          <div className="logo">
            <a href="../">
              <img src="/custom-resources/img/logo.png" alt="아소비 로고" />
            </a>
          </div>
          <div className="nav">
            <div className="gnb">
              <ul class="depth1">
                <li class="dl1">
                  <a href="/consultation" class="da1">
                    상담 신청
                  </a>
                </li>
                <li class="dl1">
                  <a href="/philosophy" class="da1">
                    아소비 이야기
                  </a>
                  <ul class="depth2">
                    <li class="dl2">
                      <a href="/philosophy" class="da2">
                        아소비 이념
                      </a>
                    </li>
                    <li class="dl2">
                      <a href="/learning" class="da2">
                        특허받은 학습법
                      </a>
                    </li>
                    <li class="dl2">
                      <a href="/program" class="da2">
                        아소비 프로그램
                      </a>
                    </li>
                  </ul>
                </li>
                <li class="dl1">
                  <a href="/process_basic" class="da1">
                    유치 프로그램
                  </a>
                  <ul class="depth2">
                    <li class="dl2">
                      <a href="/process_basic" class="da2">
                        베이직 과정
                      </a>
                    </li>
                    <li class="dl2">
                      <a href="/process_grow" class="da2">
                        그로우 과정
                      </a>
                    </li>
                    <li class="dl2">
                      <a href="/process_master" class="da2">
                        마스터 과정
                      </a>
                    </li>
                  </ul>
                </li>
                <li class="dl1">
                  <a href="/program_elementary1" class="da1">
                    초등 프로그램
                  </a>
                  <ul class="depth2">
                    <li class="dl2">
                      <a href="/program_elementary1" class="da2">
                        초등 1학년
                      </a>
                    </li>
                    <li class="dl2">
                      <a href="/program_elementary2" class="da2">
                        초등 2학년
                      </a>
                    </li>
                    <li class="dl2">
                      <a href="/program_elementary3" class="da2">
                        <p>
                          <span>예비</span>초등 3학년
                        </p>
                      </a>
                    </li>
                  </ul>
                </li>
                <li class="dl1">
                  <a href="/program_learning" class="da1">
                    특별 프로그램
                  </a>
                  <ul class="depth2">
                    <li class="dl2">
                      <a href="/program_learning" class="da2">
                        두뇌 톡톡
                      </a>
                    </li>
                    <li class="dl2">
                      <a href="/program_language" class="da2">
                        언어 톡톡
                      </a>
                    </li>
                    <li class="dl2">
                      <a href="/program_inquiry" class="da2">
                        탐구(사회/역사)
                      </a>
                    </li>
                  </ul>
                </li>
                <li class="dl1">
                  <a href="/presence" class="da1">
                    아소비 입회
                  </a>
                  <ul class="depth2">
                    <li class="dl2">
                      <a href="/diagnostic" class="da2">
                        진단 테스트
                      </a>
                    </li>
                    <li class="dl2">
                      <a href="/sptp" class="da2">
                        SPTP 검사
                      </a>
                    </li>
                    <li class="dl2">
                      <a href="/branch" class="da2">
                        우리 동네 아소비
                      </a>
                    </li>
                  </ul>
                </li>
                <li class="dl1">
                  <a href="/startUp" class="da1">
                    아소비 창업
                  </a>
                  <ul class="depth2">
                    <li class="dl2">
                      <a href="/startInfo" class="da2">
                        창업 안내
                      </a>
                    </li>
                    <li class="dl2">
                      <a href="/startProcess" class="da2">
                        창업 절차
                      </a>
                    </li>
                    <li class="dl2">
                      <a href="/benefit" class="da2">
                        지원 혜택
                      </a>
                    </li>
                    <li class="dl2">
                      <a href="/asobimanager" class="da2">
                        아소비 지사장
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
            <div className={`menu ${isAllMenuOpen ? "sel" : ""}`}>
              <button
                type="button"
                id="allmenu"
                onClick={toggleAllMenu}
                className={isAllMenuOpen ? "sel" : ""}
              ></button>
              <a
                id="search"
                href="/branch"
                className={isAllMenuOpen ? "sel" : ""}
              >
                <p className="skip">우리 동네 아소비</p>
              </a>
              {isAllMenuOpen && (
                <div className="allmenu">
                  <div className="ico">
                    <a href="../">
                      <img src="../custom-resources/img/logo.png" alt="" />
                    </a>
                  </div>
                  <div className="con">
                    <ul className="dp1">
                      <li
                        ref={(el) => (liRefs.current[0] = el)}
                        className="cg1"
                      >
                        <a href="/consultation" className="cg1_a">
                          상담 신청
                        </a>
                      </li>
                      <li
                        ref={(el) => (liRefs.current[1] = el)}
                        className="cg1"
                      >
                        <button
                          type="button"
                          className="cg1_a"
                          onClick={() => handleMenuClick(1)}
                        >
                          아소비 이야기<i></i>
                        </button>
                        <ul className="dp2">
                          <li className="cg2">
                            <a href="/philosophy" className="cg2_a">
                              아소비 이념
                            </a>
                          </li>
                          <li className="cg2">
                            <a href="/learning" className="cg2_a">
                              특허받은 학습법
                            </a>
                          </li>
                          <li className="cg2">
                            <a href="/program" className="cg2_a">
                              아소비 프로그램
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li
                        ref={(el) => (liRefs.current[2] = el)}
                        className="cg1"
                      >
                        <button
                          type="button"
                          className="cg1_a"
                          onClick={() => handleMenuClick(2)}
                        >
                          유치 프로그램<i></i>
                        </button>
                        <ul className="dp2">
                          <li className="cg2">
                            <a href="/process_basic" className="cg2_a">
                              베이직 과정
                            </a>
                          </li>
                          <li className="cg2">
                            <a href="/process_grow" className="cg2_a">
                              그로우 과정
                            </a>
                          </li>
                          <li className="cg2">
                            <a href="/process_master" className="cg2_a">
                              마스터 과정
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li
                        ref={(el) => (liRefs.current[3] = el)}
                        className="cg1"
                      >
                        <button
                          type="button"
                          className="cg1_a"
                          onClick={() => handleMenuClick(3)}
                        >
                          초등 프로그램<i></i>
                        </button>
                        <ul class="dp2">
                          <li class="cg2">
                            <a href="/program_elementary1" class="cg2_a">
                              초등 1학년
                            </a>
                          </li>
                          <li class="cg2">
                            <a href="/program_elementary2" class="cg2_a">
                              초등 2학년
                            </a>
                          </li>
                          <li class="cg2">
                            <a href="/program_elementary3" class="cg2_a">
                              <p>
                                <span>예비</span>초등 3학년
                              </p>
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li
                        ref={(el) => (liRefs.current[4] = el)}
                        className="cg1"
                      >
                        <button
                          type="button"
                          className="cg1_a"
                          onClick={() => handleMenuClick(4)}
                        >
                          특별 프로그램<i></i>
                        </button>
                        <ul className="dp2">
                          <li className="cg2">
                            <a href="/program_learning" className="cg2_a">
                              두뇌 톡톡
                            </a>
                          </li>
                          <li className="cg2">
                            <a href="/program_language" className="cg2_a">
                              언어 톡톡
                            </a>
                          </li>
                          <li className="cg2">
                            <a href="/program_language" className="cg2_a">
                              탐구(사회/역사)
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li
                        ref={(el) => (liRefs.current[5] = el)}
                        className="cg1"
                      >
                        <button
                          type="button"
                          className="cg1_a"
                          onClick={() => handleMenuClick(5)}
                        >
                          아소비 입회<i></i>
                        </button>
                        <ul className="dp2">
                          <li className="cg2">
                            <a href="/diagnostic" className="cg2_a">
                              진단테스트
                            </a>
                          </li>
                          <li className="cg2">
                            <a href="/sptp" className="cg2_a">
                              SPTP 검사
                            </a>
                          </li>
                          <li className="cg2">
                            <a href="/branch" className="cg2_a">
                              우리 동네 아소비
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li
                        ref={(el) => (liRefs.current[6] = el)}
                        className="cg1"
                      >
                        <button
                          type="button"
                          className="cg1_a"
                          onClick={() => handleMenuClick(6)}
                        >
                          아소비 창업<i></i>
                        </button>
                        <ul className="dp2">
                          <li className="cg2">
                            <a href="/startUp" className="cg2_a">
                              아소비 창업
                            </a>
                          </li>
                          <li className="cg2">
                            <a href="/startInfo" className="cg2_a">
                              창업 안내
                            </a>
                          </li>
                          <li className="cg2">
                            <a href="/startProcess" className="cg2_a">
                              창업 절차
                            </a>
                          </li>
                          <li className="cg2">
                            <a href="/benefit" className="cg2_a">
                              지원 혜택
                            </a>
                          </li>
                          <li className="cg2">
                            <a href="/asobimanager" className="cg2_a">
                              아소비 지사장
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li
                        ref={(el) => (liRefs.current[7] = el)}
                        className="cg1"
                      >
                        <button
                          type="button"
                          className="cg1_a"
                          onClick={() => handleMenuClick(7)}
                        >
                          아소비 소식<i></i>
                        </button>
                        <ul className="dp2">
                          <li className="cg2">
							<a href="/news" className="cg2_a">
                              아소비 뉴스
                            </a>
                          </li>
                          <li className="cg2">
                            <a href="/event" className="cg2_a">
                              아소비 이벤트
                            </a>
                          </li>
                          <li className="cg2">
                            <a href="/social" className="cg2_a">
                              아소비 소셜미디어
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li
                        ref={(el) => (liRefs.current[8] = el)}
                        className="cg1"
                      >
                        <button
                          type="button"
                          className="cg1_a"
                          onClick={() => handleMenuClick(8)}
                        >
                          회사 소개<i></i>
                        </button>
                        <ul className="dp2">
                          <li className="cg2">
                            <a href="/company" className="cg2_a">
                              아소비 철학
                            </a>
                          </li>
                          <li className="cg2">
                            <a href="/history" className="cg2_a">
                              주요 연혁
                            </a>
                          </li>
                          <li className="cg2">
                            <a href="/location" className="cg2_a">
                              오시는 길
                            </a>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                  <div className="bot">
                    <ul>
                      <li>
                        <a href="/branch">
                          <strong>
                            <span style={{ color: "#000000" }}>
                              아소비 교육원 찾기
                            </span>
                            <span style={{ color: "#FF8000" }}> 클릭!</span>
                          </strong>
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.youtube.com/c/%EC%95%84%EC%86%8C%EB%B9%84"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          유튜브
                        </a>
                        <a
                          href="https://spring.asobi.co.kr/landing/animation_ibosa"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          애니메이션
                        </a>
                        <a href="/customer">고객센터</a>
                        <a href="/app">아소비 앱</a>
                      </li>
                    </ul>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {children}
    </header>
  );
};

export default Header;
